<template>
  <div>
    <core-filter />
    <router-view />
  </div>
</template>
<script>
import CoreFilter from '@/components/core/menu.vue'

export default {
  components: {
    CoreFilter,
  },
}
</script>
